import { combineReducers } from 'redux';

import manageTruckRoutesList from './managetruckrouteslist/reducer';
import createEditTruckRoute from './createedittruckroute/reducer';
import manageTruckRouteScheduleList from './managetruckrouteschedulelist/reducer';
import createEditTruckRouteSchedule from './createedittruckrouteschedule/reducer';
import tabSettingsState from './settings/reducer';

export default combineReducers({
  manageTruckRoutesList,
  createEditTruckRoute,
  manageTruckRouteScheduleList,
  createEditTruckRouteSchedule,
  tabSettingsState
});



// WEBPACK FOOTER //
// ./src/pages/inventory/truckroutes/state/reducers.js